//
// Error
import { Data } from "effect";
export class SecretUnsealerError extends Data.TaggedError("@open-revenue/utils/SecretUnsealer/SecretUnsealerError") {
    reason;
    error;
    constructor(reason, error){
        super({
            reason,
            error
        }), this.reason = reason, this.error = error;
    }
}
